import { ISOCalendarDate, ISOTime } from '@/utils/date/types';

import { ScheduleSetForm, ScheduleEditForm } from '@/components/calendar/forms/schedule/types';

interface BackendScheduleDateUpdateRequest {
    date: ISOCalendarDate,
    timeStart: ISOTime,
    timeEnd: ISOTime,
    clinicId: number,
}

interface BackendSchedule {
    /*
        schedules[{number}][time_start]
        schedules[{number}][time_end]
        schedules[{number}][clinic_id]
    */
    [key: string]: string,
    startDate: string,
    endDate: string,
}

// client-to-server

export const transformScheduleDate = (schedule: ScheduleEditForm): Partial<BackendScheduleDateUpdateRequest> => {
    if (schedule.clinic == null) {
        throw new Error('Не указана клиника')
    }

    if (schedule.schedule == null) {
        throw new Error('Не заполнено расписание')
    }

    return {
        date: schedule.date,
        clinicId: schedule.clinic.id,
        timeStart: schedule.schedule.from,
        timeEnd: schedule.schedule.to,
    };
}

export const transformScheduleTemplate = (schedule: ScheduleSetForm): BackendSchedule => {
    const daysEntries = schedule.schedule.map((day) => {
        // don't send disabled days
        if (!day.enabled) {
            return []
        }

        const clinicId = day.clinic?.id ?? '';

        return [
            [`schedules[${day.weekday}][time_start]`, day.from],
            [`schedules[${day.weekday}][time_end]`, day.to],
            [`schedules[${day.weekday}][clinic_id]`, clinicId],
        ]
    });

    const days = Object.fromEntries(
        daysEntries.flat()
    );

    return {
        ...days,
        startDate: schedule.from,
        endDate: schedule.to,
    }
}
